export { default } from './collect-kyb-data-navigation-header';
